import { useQuery } from '@tanstack/react-query';
import { listParameterTargets, type ResolvedParameterTarget } from '../services/parameterTargetService';

/** Query key of an aquarium's parameter targets; set-point saves invalidate it (and ['measurements']). */
export function parameterTargetsKey(aquariumId: string | null | undefined): readonly unknown[] {
  return ['parameterTargets', aquariumId];
}

/** Every parameter's target in force for the aquarium (personal set point or hobby default). */
export function useParameterTargets(aquariumId: string | null | undefined) {
  return useQuery<ResolvedParameterTarget[], Error>({
    queryKey: parameterTargetsKey(aquariumId),
    queryFn: () => listParameterTargets(aquariumId as string),
    enabled: Boolean(aquariumId),
  });
}
